<p-card header="Оплата {{ data.datePayment }}">
  <table class="table table-sm table-striped">
    <tbody>
      <tr>
        <td style="width: 15%;" class="font-bold">Статус</td>
        <td style="width: 35%;">
          <span *ngIf="!data.isPayment" class="badge badge-secondary">БЕСПЛАТНО</span>
          <span *ngIf="data.isPayment" class="badge badge-success">ОПЛАЧЕНО</span>
        </td>
        <td style="width: 15%;" class="font-bold">Материалы</td>
        <td style="width: 35%;">
          <span *ngIf="!data.isMaterials" class="badge badge-secondary">НЕТ</span>
          <span *ngIf="data.isMaterials" class="badge badge-success">ДА</span>
        </td>
      </tr>
      <tr *ngIf="data.isPayment">
        <td style="width: 15%;" class="font-bold">Сумма</td>
        <td style="width: 35%;">
          <span *ngIf="data.isPayment" class="badge badge-info">
            {{ data.paymentAmount }}
          </span>
        </td>
        <td style="width: 15%;" class="font-bold">Дата</td>
        <td style="width: 35%;">
          {{ data.datePayment }}
        </td>
      </tr>
      <tr *ngIf="data.isPayment">
        <td style="width: 15%;" class="font-bold">Оплата</td>
        <td style="width: 35%;">{{ data.paymentTypeName }}</td>
        <td style="width: 15%;">
          <span *ngIf="data.sponsorName" class="font-bold">Компания</span>
        </td>
        <td style="width: 35%;">
          <span *ngIf="data.sponsorName">
            {{ data.sponsorName }}
          </span>
        </td>
      </tr>
      <tr *ngIf="data.paymentDocument">
        <td style="width: 15%;" class="font-bold">Документ</td>
        <td colspan="3" style="width: 85%;">{{ data.paymentDocument }}</td>

      </tr>
    </tbody>
  </table>
  <!-- <dl class="row">
    <dt class="col-sm-3">Статус</dt>
    <dd class="col-sm-3">
      <span *ngIf="!data.isPayment" class="badge badge-secondary">БЕСПЛАТНО</span>
      <span *ngIf="data.isPayment" class="badge badge-success">ОПЛАЧЕНО</span>
    </dd>
    <dt class="col-sm-4">Выданы материалы</dt>
    <dd class="col-sm-2">
      <span *ngIf="!data.isMaterials" class="badge badge-secondary">НЕТ</span>
      <span *ngIf="data.isMaterials" class="badge badge-success">ДА</span>
    </dd>
  </dl> -->
  <!-- <dl class="row" *ngIf="data.isPayment">
    <dt class="col-sm-3">Сумма</dt>
    <dd class="col-sm-3">
      <span *ngIf="data.isPayment" class="badge badge-info">
        {{ data.paymentAmount }}
      </span>
    </dd>

    <dt class="col-sm-2">Дата</dt>
    <dd class="col-sm-4"> {{ data.datePayment }} </dd>

    <dt class="col-sm-3">Тип оплаты</dt>
    <dd class="col-sm-9"> {{ data.paymentTypeName }} </dd>

    <dt class="col-sm-3" *ngIf="data.sponsorName">Компания</dt>
    <dd class="col-sm-9" *ngIf="data.sponsorName">{{ data.sponsorName }} </dd>

    <dt class="col-sm-3" *ngIf="data.paymentDocument">Документ</dt>
    <dd class="col-sm-9" *ngIf="data.paymentDocument"> {{ data.paymentDocument }} </dd>
  </dl> -->
  <ng-template pTemplate="footer" *ngIf="!isReadOnly">
    <p-button label="Редактировать" styleClass="p-button-warning mr-2" (click)="onEdit()"></p-button>
  </ng-template>
</p-card>
